import axiosInstance from "../config/axiosInstance.config";

export const httpGet = (url: string) => {
  return axiosInstance.get(url);
};

export const httpPost = <T>(url: string, data: T) => {
  return axiosInstance.post(url, data);
};

export const httpPostWithFormData = <T>(
  url: string,
  data: T,
  headers?: any
) => {
  headers = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  };

  return axiosInstance.post(url, data, headers);
};
